import PropTypes from "prop-types";

// @mui material components
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";

// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";

// Argon Dashboard 2 MUI base styles
import typography from "assets/theme/base/typography";

function Footer({ company: companyProp = { href: "https://prmcore.com/", name: "PRM Core" } }) {
  const defaultCompany = { href: "https://prmcore.com/", name: "PRM Core" };
  const company = companyProp || defaultCompany;

  const href = company?.href || defaultCompany.href;
  const name = company?.name || defaultCompany.name;
  const { size } = typography;

  return (
    <ArgonBox
      width="100%"
      display="flex"
      flexDirection={{ xs: "column", lg: "row" }}
      justifyContent="center"
      alignItems="center"
      px={1.5}
      py={2}
    >
      <ArgonBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
        color="text"
        fontSize={size.sm}
        px={1.5}
        textAlign="center"
      >
        &copy; {new Date().getFullYear()}, made with
        <ArgonBox fontSize={size.md} color="text" mb={-0.5} mx={0.25}>
          <Icon color="inherit" fontSize="inherit">
            favorite
          </Icon>
        </ArgonBox>
        by
        <Link href={href} target="_blank" rel="noreferrer">
          <ArgonTypography variant="button" fontWeight="medium">
            &nbsp;{name}&nbsp;
          </ArgonTypography>
        </Link>
        for property management.
      </ArgonBox>
    </ArgonBox>
  );
}


Footer.propTypes = {
  company: PropTypes.objectOf(PropTypes.string),
};

export default Footer;
